"use client"

import { useEffect } from "react"
import { usePathname, useSearchParams } from "next/navigation"
import { pageView } from "../utils/gtm"
import { unstable_noStore as noStore } from "next/cache"

const Analytics = () => {
    noStore()
    const pathname = usePathname()
    const searchParams = useSearchParams()
    const facilityCode = searchParams.get("code") || ""
    const mode = searchParams.get("mode") || ""

    useEffect(() => {
        pageView(pathname, facilityCode, mode)
    }, [pathname, facilityCode, mode])

    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV !== "production") {
        return null
    }

    return <></>
}

export default Analytics
